import { FormGroup, Input, Label } from "reactstrap";
import { CommonFileInputProp } from "../../../../../Type/CommonComponant";

const CommonFileInput = ({ label, multiple, disabled, size }: CommonFileInputProp) => {
  return (
    <FormGroup>
      <Label check>{label}</Label>
      <Input type="file" multiple={multiple} disabled={disabled} bsSize={size} />
    </FormGroup>
  );
};

export default CommonFileInput;
